class ValidationService {
  //NOTE: all these validations are from VA

  static isValidEmail(value, isRequired) {
    if (!isRequired && !value) {
      return true;
    }

    //Taken from VA it says empty values are false, so we check empty values at the top for our purposes
    let reChars = /^[a-zA-Z0-9!#$%&'*+\-/=?^_`{|}~.@]+$/  // eslint-disable-line no-useless-escape
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line no-useless-escape
    if (re.test(value)) {
      return reChars.test(value)
    }
    return false
  }

  static isValidName(value) {
    let re = /^[A-Za-zÀ-ÖØ-öø-ÿ ’'\-\.]+$/   // eslint-disable-line no-useless-escape
    return re.test(value);
  }

  static isValidFirstName(value) {
    return this.isValidName(value) && value.length < 30;
  }

  static validateLastName(value) {
    return !value || this.isValidName(value);
  }

  static isValidPhoneNumber(value) {
    let digits = this._extractDigits(value);
    return Array.isArray(digits) && digits.length === 10
  }

  static _extractDigits(data) {
    if (!data)
    {
      return []
    }

    try {
      const matches = data.match(/\d/g)
      if (matches != null)
      {
        return matches.map(Number)
      }
    } catch (ex) {
      console.log("phoneTextInput.js/ExtractDigits/ data.match fail - " + ex.message);
    }

    return []
  }
}

export default ValidationService;